import {computeIsGlobalNamespace, isTeamNamespace} from '../../helpers/namespaceHelpers';
import {NamespacePayload} from './payloadTypes';

export interface SettingsContextPayload extends NamespacePayload {
  settings_type: SettingsTrackingTypesEnum;
  settings_page?: string;
  settings_subpage?: string;

  // For macros tracking
  macro_id?: string | number;
  recipe_id?: string | number;

  // For rule tracking
  is_branching_rule?: boolean;
}

export enum SettingsTrackingTypesEnum {
  COMPANY = 'company',
  TEAM = 'team',
  PERSONAL = 'personal',
}

/*
 * Helpers.
 */

export function computeSettingsTrackingType(namespace: string): SettingsTrackingTypesEnum {
  if (isTeamNamespace(namespace)) {
    return SettingsTrackingTypesEnum.TEAM;
  }
  if (computeIsGlobalNamespace(namespace)) {
    return SettingsTrackingTypesEnum.COMPANY;
  }
  return SettingsTrackingTypesEnum.PERSONAL;
}
